/**
 * Marks a `project_framework` row the user wrote. A prefix rather than a flag
 * column: the sidebar, the route and the source chip all need the answer before
 * any data is in hand, and every catalogue id is `XX-N`, so the two cannot
 * collide.
 */
export const CUSTOM_FRAMEWORK_ID_PREFIX = "custom:";
export const isCustomFrameworkId = (frameworkId) => frameworkId.startsWith(CUSTOM_FRAMEWORK_ID_PREFIX);
/**
 * Initials of the first three words: "Reconciliation Action Plan" → "RAP". A
 * single word takes four characters, because "R" is not an identifier.
 *
 * A DEFAULT, not a derivation — renaming leaves the abbreviation alone, since
 * that is what the sidebar has been showing.
 */
export const suggestFrameworkAbbreviation = (name) => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return "";
    }
    if (words.length === 1) {
        return words[0].slice(0, 4).toUpperCase();
    }
    return words
        .slice(0, 3)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
};
/**
 * Case- and whitespace-insensitive "does this value already exist among these
 * frameworks" check, over whichever field `select` reads. `excludeId` lets an
 * edit run without the row objecting to itself. Shared by
 * `isDuplicateFrameworkName` and (in `../index`) `isDuplicateFrameworkAbbreviation`
 * — same shape, different field.
 */
export const isDuplicateBy = (value, frameworks, select, excludeId) => {
    const candidate = value.trim().toLowerCase();
    return frameworks.some((framework) => framework.id !== excludeId &&
        select(framework)?.trim().toLowerCase() === candidate);
};
/**
 * Case- and whitespace-insensitive: "RAP" and "rap " would give two sidebar
 * entries with no way to tell them apart. `excludeId` lets a rename run without
 * the row objecting to itself.
 */
export const isDuplicateFrameworkName = (name, frameworks, excludeId) => isDuplicateBy(name, frameworks, (framework) => framework.frameworkName, excludeId);
